import { compose, withHandlers } from 'recompose';
import { addProps } from 'utils/recompose';
import styles from './styles.module.scss';

const optionStyles = ({ design, selectedTemplateId }) => {
  return design.templateId === selectedTemplateId
    ? styles.optionIconSelected
    : styles.optionIcon;
};

const onClick = ({ design, selectTemplateId }) => () => {
  selectTemplateId(design.templateId);
};

export default compose(withHandlers({ onClick }), addProps({ optionStyles }));
